export enum tierName {
  basicReward = 'basicReward',
  plusReward = 'plusReward',
}